import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.word.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_WORD_ASYNC: `${uid}.saveWordAsync`,
    SAVE_WORD_SUCCESS: `${uid}.saveWordSuccess`,
    SAVE_WORD_FAILURE: `${uid}.saveWordFailure`,
    CREATE_WORD: `${uid}.createPinyin`,
};

export { ActionTypes };
